import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function PhoneCall({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>PhoneCall</title>
      <path
        d="M12.8432 18.1568C14.5559 19.0188 16.5723 19.6404 18.9375 19.9063C19.5115 19.9709 20 19.511 20 18.9334V16.7808C20 16.3219 19.6877 15.9219 19.2425 15.8106L16.5493 15.1373C16.2085 15.0521 15.848 15.152 15.5996 15.4004L12.8432 18.1568ZM12.8432 18.1568C9.72749 16.5888 7.61705 14.225 6.24117 11.7588M6.24117 11.7588C4.93032 9.40926 4.28622 6.96674 4.07481 5.03084C4.01343 4.46884 4.46855 4 5.03389 4H7.1802C7.65688 4 8.06729 4.33646 8.16078 4.80388L8.89504 8.47521C8.96061 8.80307 8.85799 9.14201 8.62157 9.37843L6.24117 11.7588Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M13.0972 6.35574C12.6906 6.27671 12.2969 6.54225 12.2179 6.94886C12.1388 7.35546 12.4044 7.74915 12.811 7.82818L13.0972 6.35574ZM16.1775 11.2183C16.2537 11.6255 16.6456 11.8937 17.0527 11.8175C17.4598 11.7414 17.7281 11.3495 17.6519 10.9424L16.1775 11.2183ZM13.1883 2.32273C12.7772 2.27225 12.403 2.56461 12.3525 2.97574C12.302 3.38686 12.5944 3.76107 13.0055 3.81155L13.1883 2.32273ZM20.1813 10.9375C20.2347 11.3483 20.6109 11.638 21.0217 11.5846C21.4325 11.5313 21.7222 11.1551 21.6689 10.7443L20.1813 10.9375ZM12.811 7.82818C13.6473 7.99074 14.4154 8.40089 15.0157 9.0054L16.0801 7.94845C15.2679 7.13058 14.2287 6.57568 13.0972 6.35574L12.811 7.82818ZM15.0157 9.0054C15.616 9.60992 16.0208 10.3809 16.1775 11.2183L17.6519 10.9424C17.4399 9.80942 16.8923 8.76633 16.0801 7.94845L15.0157 9.0054ZM13.0055 3.81155C14.8227 4.03468 16.5141 4.85598 17.8133 6.1461L18.8702 5.08174C17.3349 3.55706 15.336 2.58643 13.1883 2.32273L13.0055 3.81155ZM17.8133 6.1461C19.1124 7.43621 19.9455 9.12184 20.1813 10.9375L21.6689 10.7443C21.3902 8.59853 20.4056 6.60642 18.8702 5.08174L17.8133 6.1461Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
